/* =================== SERVIÇOS HOME =================== */
$(function () {
  $(".carrosel-servicos").slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    settings: "unslick",
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        },
      },
    ],
  });
});
